var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.82352 1.40234H4.63352C2.81352 1.40234 1.72852 2.48734 1.72852 4.30734V8.49234C1.72852 10.3173 2.81352 11.4023 4.63352 11.4023H8.81852C10.6385 11.4023 11.7235 10.3173 11.7235 8.49734V4.30734C11.7285 2.48734 10.6435 1.40234 8.82352 1.40234Z",
    fill: "#92ABFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09836 8.54242C6.00336 8.54242 5.90836 8.50742 5.83336 8.43242C5.68836 8.28742 5.68836 8.04742 5.83336 7.90242L7.33336 6.40242L5.83336 4.90242C5.68836 4.75742 5.68836 4.51742 5.83336 4.37242C5.97836 4.22742 6.21836 4.22742 6.36336 4.37242L8.12836 6.13742C8.27336 6.28242 8.27336 6.52242 8.12836 6.66742L6.36336 8.43242C6.28836 8.50742 6.19336 8.54242 6.09836 8.54242Z",
    fill: "#92ABFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.4a2a54d79996f3bbce0a76d58dbd7b16.svg";
export { ForwardRef as ReactComponent };